export function getLessonRoute(lessonId: number, restart = false, forceSeparate = false): string {
  const params = new URLSearchParams({
    restart: restart.toString(),
    force_separate: forceSeparate.toString(),
  });

  let route = `/video_player/${lessonId}?${params.toString()}`;
  if (globalThis.location.pathname === '/admin') {
    route = `/admin${route}`;
  }

  return route;
}
